export default {
    RENAME_OBJECT: 'RENAME_OBJECT',
    DELETE_FILES: 'DELETE_FILES',
    MOVE_FILES: 'MOVE_FILES'
}